

















import { defineComponent } from '@vue/composition-api';

const name = 'ttam-ios14-info-step-legend';
export default defineComponent({
  name,
  props: {
    legends: { type: Array, default: () => ['used', 'reset', 'unused'] },
  },

  setup() {
    return {
      name,
    };
  },
});
